var map = {
	"./router_messageCenter.js": "N1Ap"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NZhx";


//////////////////
// WEBPACK FOOTER
// ./src/pages/messageCenter router_messageCenter\.js$
// module id = NZhx
// module chunks = 65